import { useState, useEffect } from 'react';

const useWakeLock = () => {
  const [wakeLock, setWakeLock] = useState<WakeLockSentinel | null>(null);

  const requestWakeLock = async () => {
    try {
      const wakeLock = await navigator.wakeLock.request('screen');
      setWakeLock(wakeLock);
      wakeLock.addEventListener('release', () => {
        console.log('Wake Lock was released');
        setWakeLock(null);
      });
      console.log('Wake Lock is active');
    } catch (err) {
      console.error(`There was a problem requesting the wake lock: ${err}`);
    }
  };

  const releaseWakeLock = async () => {
    if (wakeLock) {
      await wakeLock.release();
      setWakeLock(null);
    }
  };

  useEffect(() => {
    return () => {
      if (wakeLock) {
        wakeLock.release();
      }
    };
  }, [wakeLock]);

  return { requestWakeLock, releaseWakeLock };
};

export default useWakeLock;
